/* ==========================================================================
   AURIQUE — Compare Section engine
   Vanilla JS, no dependencies. Just wires up the demo "Add to Cart" state
   for the compare table and bundle CTA.
   NOTE: presentational only — wire .cmp-add-cart up to WooCommerce (or your
   cart of choice) when you integrate this into WordPress. See README.
   ========================================================================== */

(function () {
  "use strict";

  var root = document.getElementById("compare") || document.getElementById("aurique-compare-root");
  if (!root) return;

  var addButtons = Array.prototype.slice.call(root.querySelectorAll(".cmp-add-cart, .cmp-bundle-cta"));

  addButtons.forEach(function (btn) {
    var defaultLabel = btn.textContent;
    btn.addEventListener("click", function () {
      if (btn.classList.contains("is-added")) return;
      btn.classList.add("is-added");
      btn.textContent = "Added ✓";
      setTimeout(function () {
        btn.classList.remove("is-added");
        btn.textContent = defaultLabel;
      }, 1800);
    });
  });
})();
